import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';

export default function CadastroAlunoPage() {
  const [loading, setLoading] = useState(false);
  const [verificando, setVerificando] = useState(true);
  const [nomeEscola, setNomeEscola] = useState('');
  const [linkValido, setLinkValido] = useState(false);

  const token = window.location.pathname
    .split('/')
    .filter(Boolean)[1] || '';

  useEffect(() => {
    let ativo = true;

    async function verificarEscola() {
      try {
        const resposta = await api.get(
          `/public/pre-cadastro/${encodeURIComponent(token)}`
        );

        if (ativo) {
          setNomeEscola(resposta.data.nome_escola);
          setLinkValido(true);
        }
      } catch (erro) {
        if (ativo) {
          setLinkValido(false);
        }
      } finally {
        if (ativo) {
          setVerificando(false);
        }
      }
    }

    verificarEscola();

    return () => {
      ativo = false;
    };
  }, [token]);

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    cpf: '',
    data_nascimento: '',
    responsavel_nome: '',
    responsavel_whatsapp: '',
    responsavel_email: '',
    responsavel_parentesco: '',
    observacoes_saude: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!linkValido || verificando || loading) {
      return;
    }

    setLoading(true);

    try {
      await api.post(
        `/public/pre-cadastro/${encodeURIComponent(token)}`,
        form
      );

      toast.success('Pré-cadastro realizado com sucesso!');

      setForm({
        name: '',
        email: '',
        phone: '',
        cpf: '',
        data_nascimento: '',
        responsavel_nome: '',
        responsavel_whatsapp: '',
        responsavel_email: '',
        responsavel_parentesco: '',
        observacoes_saude: ''
      });

    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Erro ao realizar cadastro');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-[#141414] border border-[#27272A] rounded-2xl p-8">

        <h1 className="text-4xl font-black text-white mb-2 uppercase">
          Pré-cadastro
        </h1>

        <p className="text-zinc-400 mb-8">
          {verificando
            ? 'Identificando escola...'
            : linkValido
              ? `Escola: ${nomeEscola}`
              : 'Link de pré-cadastro inválido ou indisponível.'}
        </p>

        <form
          onSubmit={handleSubmit}
          className="space-y-4"
          style={{
            opacity: linkValido ? 1 : 0.5,
            pointerEvents: linkValido ? 'auto' : 'none'
          }}
        >

          <input
            type="text"
            placeholder="Nome completo"
            value={form.name}
            onChange={(e) => setForm({...form, name: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
            required
          />

          <input
            type="email"
            placeholder="E-mail"
            value={form.email}
            onChange={(e) => setForm({...form, email: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
            required
          />


          <input
            type="text"
            placeholder="Telefone"
            value={form.phone}
            onChange={(e) => setForm({...form, phone: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <input
            type="text"
            placeholder="CPF"
            value={form.cpf}
            onChange={(e) => setForm({...form, cpf: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <label className="block text-sm text-gray-400 mb-2">
            Data de nascimento
          </label>
          <input
            type="date"
            value={form.data_nascimento}
            onChange={(e) => setForm({...form, data_nascimento: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <input
            type="text"
            placeholder="Nome do responsável"
            value={form.responsavel_nome}
            onChange={(e) => setForm({...form, responsavel_nome: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <input
            type="text"
            placeholder="WhatsApp do responsável"
            value={form.responsavel_whatsapp}
            onChange={(e) => setForm({...form, responsavel_whatsapp: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <input
            type="email"
            placeholder="E-mail do responsável"
            value={form.responsavel_email}
            onChange={(e) => setForm({...form, responsavel_email: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />
          <input
            type="text"
            placeholder="Parentesco (mãe, pai, tutor...)"
            value={form.responsavel_parentesco}
            onChange={(e) => setForm({...form, responsavel_parentesco: e.target.value})}
            className="w-full h-12 px-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />
          <textarea
            placeholder="Observações de saúde"
            value={form.observacoes_saude}
            onChange={(e) => setForm({...form, observacoes_saude: e.target.value})}
            className="w-full h-28 p-4 rounded-xl bg-[#0A0A0A] border border-[#27272A] text-white"
          />

          <button
            type="submit"
            disabled={loading || verificando || !linkValido}
            className="w-full h-12 rounded-xl bg-[#007AFF] hover:bg-[#0066DD] text-white font-bold"
          >
            {loading ? 'ENVIANDO...' : 'REALIZAR PRÉ-CADASTRO'}
          </button>

        </form>
      </div>
    </div>
  );
}
